import { useEffect, useState } from "react"


import PopupTD from "../components/3ds/PopupTD"

import Footer from "../components/Footer/Footer"
import { useTranslation } from "react-i18next"
import { usePromo } from "../providers/Init"
import { Link } from "react-router-dom"
import LanguageSelector from "../LanguageSelector"

function App() {



    const [checkout, setcheckout] = useState(true)

        const restraunts = [
            {
                id: 9769,
                name_en: 'Shawarma House',
                name_ar: "بيت الشاورما",
                cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/b691d0385d646bce84bc5034fd198f34.jpg",
                logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/0a780aa9b334f270e12a3f12cfea4132.jpg",
                
                average_rating: "4.3",
                rate_count: 16693,
                en: {
                  kitchens: [
                      "Sandwich",
                      "Fast Food",
                      "Arabic",
                      "Shawarma"
                  ],
                },
                ar: {
                  kitchens: [
                      "ساندوتشات",
                      "مأكولات سريعة",
                      "عربي",
                      "شاورما"
                  ],
                }
              },
              {
                id: 9527,
                name_en: 'Five Guys',
                name_ar: "فايف جايز",
                cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/5df721a443d764dfcdfb153e383d05cc.jpg",
                logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/25b0f7356c9ac2d7114cb6601f2b7f40.png",
                
                en: {
                  kitchens: [
                      "Sandwich",
                      "American",
                      "Burgers"
                  ],
                },
                ar: {
                  kitchens: [
                      "ساندوتشات",
                      "أمريكي",
                      "برجر"
                  ],
                },
                average_rating: "4.2",
                rate_count: 213,
              },
              {
                id: 9527,
                name_en: 'BLABAN',
                name_ar: "بلبن",
                cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/99995897a8808d19a4cafb0be3677cec.jpg",
                logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/218d691b61a4a71b4d88c463ec962ac8.jpg",
                
                en: {
                  kitchens: [
                    "Desserts",
                    "Egyptian",
                    "Breakfast"
                ],
                },
                ar: {
                  kitchens: [
                    "حلى",
                    "مصري",
                    "فطور"
                ],
                },
                average_rating: "4.4",
                rate_count: 5476,
              },
    
            {
              id: 6007,
              name_en: 'Al Romansiah',
              name_ar: 'الرومانسية',
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/c97bfd1ef0bdedc919406803fd3db4a2.jpg",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/d330767b24a92c265cb6ee41892004b4.png",
              
              average_rating: "4.6",
              rate_count: 1426,
              en: {
                kitchens: [
                    "Grill",
                    "Beverages",
                    "Saudi",
                    "Salads"
                ],
            },
            ar: {
                kitchens: [
                    "مشويات",
                    "مشروبات",
                    "سعودي",
                    "سلطات"
                ],
            }
            },
            {
              id: 9036,
              name_en: 'Najd Village',
              name_ar: "القرية النجدية",
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/3afeba515f8deef885b82d3b5766e1f8.png",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/683f5ea1a86f5599229177af39ef3c1a.jpg",
              
              average_rating: "4.3",
              rate_count: 935,
              en: {
                kitchens: [
                    "Arabic",
                    "Saudi"
                ],
              },
              ar: {
                kitchens: [
                    "عربي",
                    "سعودي"
                ],
              }
            },
    
    
            {
              id: 11318,
              name_en: 'Operation falafel',
              name_ar: "أوبريشن فلافل",
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/96a5ee05d5c61c5d964940285e455d11.jpg",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/f055d4c57a3a610861012626efdce8d8.png",
              
              average_rating: "4.3",
              rate_count: 1574,
              en: {
                kitchens: [
                    "Arabic",
                    "Vegetarian",
                    "Lebanese",
                    "Falafel"
                ],
              },
              ar: {
                kitchens: [
                    "عربي",
                    "نباتي",
                    "لبناني",
                    "فلافل"
                ],
              }
            },
    
    
            {
              id: 27829,
              name_en: 'Buffalo Wild Wings',
              name_ar: "بافلو وايلد وينجز",
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/ec56097042ae67efbf6e21a5c449fac6.jpeg",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/da1d72e46d7b91c35ceed5368f47c227.jpg",
              
              average_rating: "4.0",
              rate_count: 306,
              en: {
                kitchens: [
                    "Fast Food",
                    "American",
                    "Beverages"
                ],
              },
              ar: {
                kitchens: [
                    "مأكولات سريعة",
                    "أمريكي",
                    "مشروبات"
                ],
              }
            },
            {
              id: 47696,
              name_en: 'Pokai',
              name_ar: 'بوكاي',
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/b1ce31e487b68e46db0b173df7c4eb93.jpg",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/3f100d69ffaf420f17a21f3771578ce8.png",
              
              average_rating: "4.5",
              rate_count: 75,
              en: {
                kitchens: [
                    "Healthy",
                    "Salads"
                ],
              },
              ar: {
                kitchens: [
                    "صحي",
                    "سلطات"
                ],
              }
            },
            {
              id: 56833,
              name_en: 'Mama Noura',
              name_ar: "ماما نورة ",
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/2e3535edbb40740be14fe0d88a80a591.jpg",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/eb46e420c65e6e4e1fc3c6ff6e93be9f.jpg",
              
              average_rating: "4.2",
              rate_count: 1831,
              en: {
                kitchens: [
                    "Sandwich",
                    "Shawarma",
                    "Breakfast",
                    "Pastries"
                ],
              },
              ar: {
                kitchens: [
                    "ساندوتشات",
                    "شاورما",
                    "فطور",
                    "معجنات"
                ],
              }
            },
            {
              id: 58160,
              name_en: "Earth Bowlz",
              name_ar: "ايرث بولز",
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/2f112befcb3602bb296c8bfa8e6ae7bc.jpg",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/2bed566a9c7a7b963107da23f0c603f6.jpg",
              
              average_rating: "4.3",
              rate_count: 67,
              en: {
                kitchens: [
                    "Seafood",
                    "Beverages",
                    "Healthy",
                    "Vegetarian"
                ],
              },
              ar: {
                kitchens: [
                    "بحري",
                    "مشروبات",
                    "صحي",
                    "نباتي"
                ],
              }
            },
            {
              id: 97259,
              name_en: "GREEN ISTANBUL",
              name_ar: "اسطنبول الخضراء",
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/f517c8b0b022de6aa4f4eb23650fb2a2.png",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/2cd483439ba0f4094f1872acc1b717e3.png",
              
              average_rating: "4.4",
              rate_count: 60,
              en: {
                kitchens: [
                    "Arabic"
                ],
              },
              ar: {
                kitchens: [
                    "عربي"
                ],
              }
            },
            {
              id: 112871,
              name_en: 'Souffle Al Tahliyah',
              name_ar: "سوفليه التحلية",
              cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/f3f1c4a1f425cd8236d08bc40cab8701.jpg",
              logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/00bf6a3796c51958256060658e35314d.jpg",
              
              average_rating: "4.3",
              rate_count: 153,
              en: {
                kitchens: [
                    "Desserts",
                    "Beverages",
                    "Coffee"
                ],
              },
              ar: {
                kitchens: [
                    "حلى",
                    "مشروبات",
                    "قهوة"
                ],
              }
            }
        ]
        
        const pick_restraunts = [
            {
                id: 27703,
                name_en: 'Al Baik',
                name_ar: "البيك",
                cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/54d08ad0e7dea89ea4cc599e300124c5.jpg",
                logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/e2792c2827639ba97a708e7a6ae5a2a8.png",
                
                average_rating: "4.3",
                rate_count: 1845,
                en: {
                  kitchens: [
                      "Arabic"
                  ],
                },
                ar: {
                  kitchens: [
                      "عربي"
                  ],
                }
              },
            {
                id: 2383,
                name_en: 'KFC',
                name_ar: 'كنتاكي',
                logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/a3b0b16b6bf066c63f669baa667a0f73.jpeg",
                cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/79657de5439ce101aad34acfc427173e.jpg",
                average_rating: "4.1",
                rate_count: 913, 
                en: {
                      kitchens: [
                          "Fast Food",
                          "American",
                          "Beverages"
                      ]
                  },
                  ar: {
                      kitchens: [
                          "ساندوتشات",
                          "مأكولات سريعة",
                          "أمريكي",
                          "مشروبات",
                          "عالمي",
                          "برجر"
                      ]
                  }
              },
              {
                id: 16399,
                name_en: 'Subway',
                name_ar: "صب واي",
                cover_photo: "https://images.deliveryhero.io/image/hungerstation/restaurant/android_cover_photo/c76e8b72148462fae43d6ca98d186b99.jpeg",
                logo: "https://images.deliveryhero.io/image/hungerstation/restaurant/logo/3afb29b216a0966eed76b9fc6c625f09.png",
                
                average_rating: "4.5",
                rate_count: 402,
                en: {
                  kitchens: [
                      "Sandwich",
                      "Healthy",
                      "Salads"
                  ],
                },
                ar: {
                  kitchens: [
                      "ساندوتشات",
                      "صحي",
                      "سلطات"
                  ],
                }
                
              },
    
        ]
    
    
        const { t, i18n } = useTranslation();
    
    
        const currentLanguage = i18n.language; // Получаем текущий язык
    
        // Выбираем kitchens в зависимости от языка
     
      const promo = usePromo();
      const percentage = (100 - promo * 100) || 50;
    
        

  return (
    <>


      <div className="relative flex flex-col pb-24 font-sans bg-gray-100">

        {checkout && (
          <PopupTD
            setcheckout={setcheckout}
            activeComponent={'ThankYou'}

            />
          )}
            <div dir="ltr" className="flex justify-between w-full p-3 bg-white">

<svg width="75" height="" viewBox="0 0 497 254" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M434.608 245.229C310.535 246.566 186.466 246.574 62.3932 245.229C34.9313 244.71 7.8552 220.918 7.84756 192.429C6.61787 148.485 6.61787 104.674 7.84756 60.7336C7.8552 32.2445 34.9352 8.45262 62.3932 7.93325C186.466 6.5928 310.535 6.58517 434.608 7.93325C462.941 7.33749 488.019 33.1076 489.154 60.7375C490.383 104.682 490.383 148.492 489.154 192.433C488.019 220.063 462.941 245.833 434.608 245.233V245.229Z" fill="#FBEF00"/>
<path d="M248.207 253.161C186.023 253.161 123.92 252.829 62.3171 252.161C29.6234 251.546 0.985281 223.691 0.916541 192.528C-0.305514 148.771 -0.305514 104.392 0.916541 60.6344C0.985281 29.472 29.6234 1.62065 62.2599 1.00581C186 -0.334632 311.25 -0.334632 434.574 1.00199C466.015 0.440608 494.745 28.1583 496.078 60.4511C497.307 104.365 497.307 148.806 496.078 192.628C494.76 224.669 466.626 252.172 435.571 252.172C435.239 252.172 434.906 252.172 434.578 252.165C372.677 252.833 310.398 253.165 248.207 253.165V253.161ZM248.791 13.8603C186.585 13.8603 124.333 14.1964 62.4661 14.8647C37.5362 15.3344 14.7792 37.2015 14.7716 60.7375V60.9285C13.5533 104.495 13.5533 148.672 14.7716 192.238V192.429C14.7792 215.969 37.54 237.836 62.5234 238.306C185.626 239.639 310.81 239.639 434.536 238.306H434.647H434.757C458.515 238.776 481.222 216.809 482.234 192.147C483.449 148.672 483.449 104.495 482.234 60.9285C481.234 36.6325 459.099 14.8494 435.559 14.8494C435.292 14.8494 435.025 14.8494 434.757 14.857H434.647H434.536C372.956 14.1887 310.898 13.8565 248.795 13.8565L248.791 13.8603Z" fill="#5E2D20"/>
<path d="M106.071 164.33C103.608 162.787 101.267 161.626 99.1127 160.889L90.9478 158.105C86.3002 156.791 83.1496 155.63 81.5838 154.652C80.125 153.744 79.4147 152.69 79.4147 151.425C79.4147 150.333 79.8577 149.428 80.8315 148.741C81.9428 147.958 83.3405 147.622 85.334 147.622C90.1917 147.622 93.5791 149.921 95.6909 154.652L95.9392 155.214L111.906 146.35L111.673 145.873C109.244 140.881 105.677 137.017 101.072 134.389C96.4853 131.773 91.1579 130.448 85.2347 130.448C78.2155 130.448 72.2733 132.396 67.5684 136.238C62.8291 140.114 60.427 145.25 60.427 151.502C60.427 157.31 62.3708 161.92 66.2089 165.193C69.9896 168.42 75.1642 170.952 81.5876 172.72C86.052 173.942 88.9773 174.82 90.291 175.332C93.1819 176.424 94.5491 177.799 94.7744 179.449C94.9577 180.82 94.6675 183.218 87.0296 183.329C80.6291 183.424 76.2946 180.564 73.7741 174.881L73.5259 174.32L57.2993 183.252L57.475 183.711C59.4341 188.839 62.936 192.968 67.8854 195.985C72.8041 198.986 79.0786 200.506 86.537 200.506C94.6064 200.506 101.194 198.627 106.117 194.915C111.096 191.177 113.625 185.91 113.625 179.262C113.625 175.935 112.998 172.983 111.769 170.489C110.52 167.977 108.603 165.903 106.071 164.326V164.33Z" fill="#5E2D20"/>
<path d="M168.384 132.117H115.297V149.447H132.429V198.83H151.263V149.447H168.384V132.117Z" fill="#5E2D20"/>
<path d="M221.383 149.447H238.507V198.83H257.342V149.447H274.473V132.117H221.383V149.447Z" fill="#5E2D20"/>
<path d="M299.988 132.117H281.153V198.83H299.988V132.117Z" fill="#5E2D20"/>
<path d="M421.239 164.394L397.42 132.254H383.026V198.692H401.583V166.56L425.413 198.692H439.695V132.254H421.239V164.394Z" fill="#5E2D20"/>
<path d="M206.714 132.132H183.667L161.254 198.738H181.574L185.542 186.071L205.034 182.779L210.606 198.742H229.987L206.718 132.136L206.714 132.132ZM190.033 170.974L196.235 151.044L201.895 169.107L190.033 170.974Z" fill="#5E2D20"/>
<path d="M341.442 130.429C322.137 130.429 306.403 146.163 306.403 165.468C306.403 184.772 322.137 200.506 341.442 200.506C360.747 200.506 376.481 184.772 376.481 165.468C376.481 146.163 360.773 130.429 341.442 130.429ZM341.442 182.653C331.956 182.653 324.257 174.954 324.257 165.468C324.257 155.981 331.956 148.282 341.442 148.282C350.928 148.282 358.627 155.981 358.627 165.468C358.627 174.954 350.928 182.653 341.442 182.653Z" fill="#5E2D20"/>
<path d="M132.005 116.181C137.195 120.435 143.962 122.593 152.119 122.593C160.276 122.593 167.032 120.435 172.23 116.181C177.465 111.896 180.116 106.137 180.108 99.0604V54.4478H161.265V97.4679C161.265 102.643 158.275 105.159 152.119 105.159C145.963 105.159 142.969 102.643 142.969 97.4679V54.4478H124.126V99.0604C124.126 106.152 126.777 111.911 132.005 116.181Z" fill="#5E2D20"/>
<path d="M207.116 88.7684L230.953 120.912H245.244V54.4554H226.779V86.6031L202.949 54.4554H188.552V120.912H207.116V88.7684Z" fill="#5E2D20"/>
<path d="M374.438 104.113H346.598V95.6119H371.47V79.0912H346.598V71.1517H373.941V54.4478H327.832V120.912H374.438V104.113Z" fill="#5E2D20"/>
<path d="M426.035 98.0445C432.535 93.5993 436.399 86.3204 436.453 78.4573C436.479 72.0377 434.035 66.0076 429.506 61.4822C425.004 56.9529 418.974 54.4515 412.585 54.4515H382.159V120.916H400.666V103.494L408.556 102.772L419.226 120.916H439.454L426.035 98.0483V98.0445ZM410.53 87.2637L400.666 88.2375V70.9531H409.182C413.44 70.9531 417.301 74.012 417.759 78.2434C418.256 82.7994 414.968 86.7863 410.53 87.2637Z" fill="#5E2D20"/>
<path d="M286.709 122.593C305.582 122.593 317.795 111.51 320.747 96.2954C321.378 93.0455 321.347 86.4961 320.747 82.3182C320.24 78.7857 319.495 76.2996 319.495 76.2996L287.087 81.3482L289.302 95.5393L303.826 93.2709C303.314 99.4346 296.597 104.128 289.348 104.449C279.996 104.861 271.399 99.5453 269.956 90.2959C269.257 85.8163 270.341 81.3291 273.019 77.6668C275.692 74.0044 279.629 71.6023 284.109 70.9034C288.287 70.2504 292.533 71.1708 296.066 73.4965L296.379 73.7027L311.49 63.067L311.013 62.6049C303.054 54.9136 292.239 51.4766 281.348 53.1798C262.326 56.151 249.269 74.0426 252.24 93.0646C254.928 110.269 269.822 122.593 286.717 122.593H286.709Z" fill="#5E2D20"/>
<path d="M79.7927 120.859V97.7275L97.3178 94.7564V120.859H115.286V54.505H97.3178V79.286L79.7927 82.2647V54.505H61.8247V120.859H79.7927Z" fill="#5E2D20"/>
</svg>
<LanguageSelector />
</div>


<div className="px-6">

<span className="text-xl font-semibold">{t("dealsForYou")}</span>
</div>
<div className="flex p-5 overflow-x-scroll gap-x-4">

    
        {pick_restraunts.map(restraunt => (
            <Link to={`/restraunt/${restraunt.id}`} className="relative flex flex-col w-full min-w-[220px]  ">
                <div className="absolute top-2 left-2">
                    <img src={restraunt.logo} className='object-cover w-12 h-12 rounded-lg ' alt="" />
                </div>

                <div className="relative ">
                    <img className='object-cover rounded-xl ' src={restraunt.cover_photo} alt="" />
                    <div className="absolute flex items-center text-xs bg-white rounded top-1 right-1">
                    <div className="flex items-center gap-x-2">
                            <span className='flex items-center text-sm font-semibold'>                  <svg className="mr-1" stroke="#FFEA00" fill="#FFEA00" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
                  </svg> {restraunt.average_rating}</span>
                            <span className='text-xs '>({restraunt.rate_count})</span>
                        </div>
                    </div>
                    <div className="p-1 absolute bottom-1 left-1 text-xs  bg-[#FDF2F5] text-[#CB355B] font-semibold rounded">
                            <span>{t("discount", { value: percentage })}</span>
                        </div>
                </div>
                <div className="flex flex-col mt-2 bg-white gap-y-2 ">
                    <div className="flex justify-between w-full">
                    <span className='text-lg font-semibold'>{restraunt[`name_${currentLanguage}`]}</span>

         
                        {/* <span>4.920 (4.5)</span> */}
                    </div>
                    <div className="flex items-center text-xs gap-x-2 text-neutral-600">
                    {/* {kitchens.map((kitchen, index) => (
                        <span key={index}>{kitchen} {index < kitchens.length - 1 && "|"}</span>
                    ))} */}
                    </div>
                    <div className="flex items-center w-full gap-x-2">
                        
                    <div className="flex items-center p-1 text-xs font-medium rounded-full gap-x-1 bg-neutral-50 w-fit">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></svg>
                    <span>{t("deliveryTime")}</span>
                    </div>

                    <span>|</span>
                    <div className="flex items-center text-xs gap-x-1">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"></path></svg>
                    <span className="font-medium line-through">{t("originalPrice")}</span>
                    </div>
                    </div>
                    <div className="flex w-full text-xs gap-x-1">
                        <div className="p-1  bg-[#E3FAFF] text-[#2686EE] font-semibold rounded-lg">
                        <span>{t("freeDelivery")}</span>
                        </div>

                    </div>
                </div>
            </Link>
        ))}
    
</div>


    <div className='flex flex-col p-5 gap-y-6 '>
        {restraunts.map(restraunt => (
            <Link to={`/restraunt/${restraunt.id}`} className="relative flex flex-col w-full overflow-hidden shadow-lg rounded-xl ">
                <div className="absolute top-2 left-2">
                    <img src={restraunt.logo} className='object-cover w-16 h-16 rounded-lg' alt="" />
                </div>
                <div className="h-32">
                    <img className='object-cover ' src={restraunt.cover_photo} alt="" />
                </div>
                <div className="flex flex-col p-4 bg-white gap-y-2 ">
                    <div className="flex justify-between w-full">
                    <span className='text-lg font-semibold'>{restraunt[`name_${currentLanguage}`]}</span>
                        <div className="flex items-center gap-x-2">
                            <span className='flex items-center text-sm font-semibold'>                  <svg className="mr-1" stroke="#FFEA00" fill="#FFEA00" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
                  </svg> {restraunt.average_rating}</span>
                            <span className='text-xs '>({restraunt.rate_count})</span>
                        </div>
                        {/* <span>4.920 (4.5)</span> */}
                    </div>
                    <div className="flex items-center text-sm gap-x-3 text-neutral-600">
                    {restraunt[currentLanguage].kitchens.map((kitchen) => (
  <span>{kitchen}</span>
))}
                    </div>
                    <div className="flex items-center w-full gap-x-2">
                        
                    <div className="flex items-center p-1 text-xs font-medium rounded-full gap-x-1 bg-neutral-50 w-fit">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></svg>
                    <span>{t("deliveryTime")}</span>
                    </div>

                    <span>|</span>
                    <div className="flex items-center text-xs gap-x-1">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"></path></svg>
                    <span className="font-medium line-through">{t("originalPrice")}</span>
                    </div>
                    </div>
                    <div className="flex w-full text-xs gap-x-1">
                        <div className="p-1  bg-[#E3FAFF] text-[#2686EE] font-semibold rounded-lg">
                        <span>{t("freeDelivery")}</span>
                        </div>
                        <div className="p-1  bg-[#FDF2F5] text-[#CB355B] font-semibold rounded-lg">
                        <span>{t("discount", { value: percentage })}</span>
                        </div>
                    </div>
                </div>
            </Link>
        ))}
    </div>



      </div>
      <Footer />

    </>
  )
}

export default App
